<template>
	<div>
		<v-card class="mx-auto experienceCard" max-width="280" :loading="loading">
			<template v-slot:loader="{ isActive }">
				<v-progress-linear
					:active="isActive"
					color="deep-purple"
					height="4"
					indeterminate
				></v-progress-linear>
			</template>
			<v-img
				v-if="experience.img_path"
				:src="`${experience.img_path}`"
				height="200px"
				cover
				class="fitProductImage"
			></v-img>
			<v-img
				v-else
				src="@/assets/static/images/noImage.png"
				height="200px"
				cover
				class="fitProductImage"
			></v-img>
			<div style="text-align: left">
				<div class="card-title bold">{{experience.name}}</div>
				<!-- <v-card-subtitle style="padding-top: 0px;">{{experience.category_names}}</v-card-subtitle> -->
			</div>

			<div class="trashIcon" @click="deleteExperience">
				<font-awesome-icon icon="trash" />
			</div>
		</v-card>
		<ConfirmDialog :visible="showConfirmation" class="customClass"></ConfirmDialog>
	</div>
</template>

<script>
import ConfirmDialog from 'primevue/confirmdialog';

export default {
components: {
    ConfirmDialog,
  },
  data() {
    return {
      id: this.experience.id,
	  loading: false,
	  showConfirmation: false,
    }
  },
  methods: {
    openInNewTab(url) {
     	window.open(url, '_blank')
    },
	reserve () {
        this.loading = true
        setTimeout(() => (this.loading = false), 2000)
    },
	deleteExperience(event) {
		event.stopPropagation()
		this.$confirm.require({
                message: this.$t('confirmExperienceDelete'),
                header: this.$t('areYouSure'),
                icon: 'pi pi-exclamation-triangle',
				acceptLabel: this.$t('yes'),
				rejectLabel: this.$t('no'),
				acceptIcon: 'pi pi-check',
        		rejectIcon: 'pi pi-times',
                accept: () => {
					this.$store
					.dispatch('experience/removeExperience', this.id)
					.then(() => {
						this.$emit('refresh-experience-list', null)
					})
					.catch((e) => console.log(e))
                },
                reject: () => {
					this.showConfirmation = false;
                }
        });
	},
    setFeatured(featuredFlag) {
      this.experience.featured = featuredFlag
      const body = {
        id: this.experience.id,
        featured: featuredFlag
      }
      this.$store.dispatch('experience/upsertExperience', body)
    }
  },
  props: {
    experience: {
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.fitProductImage {
	width: 100% !important;
  	object-fit: cover !important;
}

.experienceCard {
	height: 280px;
	margin: 20px 10px !important;
}
.experienceCard:hover {
	background: rgba(128, 128, 128, 0.1) !important;
	box-shadow: rgba(0, 0, 0, 0.117647) 0px 1px 6px, rgba(0, 0, 0, 0.117647) 0px 1px 4px;
	margin: 10px !important;
	transform: scale(1.03);
}

.card-title {
	width: 225px;
	overflow: hidden;
	text-overflow: ellipsis;
	-webkit-line-clamp: 2;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	margin-top:15px;
	margin: 10px;
	text-align: left;
	font-size: 1.1rem;
	font-weight: 800;
}
.bold {
	font-weight: 700 !important;

}
.card {
  box-shadow: rgba(0, 0, 0, 0.117647) 0px 1px 6px, rgba(0, 0, 0, 0.117647) 0px 1px 4px;
  transition: .15s all ease-in-out;
  &:hover {
    transform: scale(1.1);
  }
}

.iconWrapper {
	display: flex;
	flex-wrap: nowrap;
	align-items: left;
	justify-content: left;
	margin: -10px -5px 5px -5px;
}

.iconWrapper div {
    padding: 7px;
	margin-left: 2px;
    border-radius: 50%;
    color: var(--bright);
	align-self: flex-end;
}

.trashIcon {
	background: var(--primaryDark);
	color: var(--bright);
	cursor: pointer !important;
	padding: 10px;
	border: none;
	border-radius: 5px;
	width: 35px;
	height: 40px;
    position: absolute;
    right: 10px;
    margin: 0;
    bottom: 10px;
}

@media only screen and (max-device-width: 769px) {
	.experienceCard {
		height: auto !important;
	}
}

@media screen and (max-width: 500px) {
  .experienceCard {
    margin: auto;
	margin-bottom: 0px !important;
	min-height: 260px;
  }
  .card-title {
		margin-top: 10px;
		width: 225px !important;
  }
  .card-title:hover {
	text-decoration:none;
  }
  .card-img-top {
    max-width: 180px;
    max-height: 150px;
}
}

@media only screen and (min-device-width: 300px) and (max-device-width: 359px){
	.card-title {
	width: 240px;
	font-size: 1.2rem;
	text-align: left;
}
}

@media only screen and (min-device-width: 360px) and (max-device-width: 379px){
	.card-title {
	width: 270px;
}
}
</style>
